import { createResponsiveStateReducer } from 'redux-responsive';
import brand from '../components/brand/ducks/index.js';
import translations from '../components/translation/ducks/index';
import resources from '../components/resource/ducks/index.js';
import notifications from '../components/notifications/ducks/notifications.js';
import notificationsQueue from '../components/notifications/ducks';
import formSubmit from '../components/forms/ducks/index.js';
import cookies from '../store/ducks/cookies.js';
import scroll from '../components/scroll/ducks/index.js';
import appBanner from '../components/app-banner/ducks/index.js';
import resetPassword from '../components/authentication/reset-password/ducks/index';
import bankId from '~/components/authentication/bankid/ducks';

export default {
	browser: createResponsiveStateReducer(
		{ small: 767, medium: 992, large: 1200, extraLarge: 1750 },
		{
			extraFields: () => ({
				width: window.innerWidth
			})
		}
	),
	brand,
	cookies,
	translations,
	resources,
	notifications,
	formSubmit,
	scroll,
	appBanner,
	resetPassword,
	notificationsQueue,
	bankId
};
